import React, {useState, useEffect} from 'react';
import DraggableList from '../../common/draggable-list';
import SubSection from '../../../libs/react-components-admin/section/sub-section';

const Color = ({value, onChange}) => {

  const [model, setModel] = useState(value || []);

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  };

  useEffect(() => {
    setModel(value || []);
  }, [ value ]);

  const header = <li className="list-group-item">
    <div className="row text-center">
      <div className="col-5">
        Hex code
      </div>
      <div className="col-5">
        Name (optional)
      </div>
    </div>
  </li>;

  const renderItem = (item, i) => {
    return <div className="row">
      <div className="col-5">
        <input type="text"
               className="form-control"
               value={item.hex || ''}
               onChange={e => setModelAndNotify(model.map((v, j) => j !== i ? v : {...v, hex: e.target.value}))}
               placeholder="#123456"/>
      </div>
      <div className="col">
        <input type="text"
               className="form-control"
               value={item.name || ''}
               onChange={e => setModelAndNotify(model.map((v, j) => j !== i ? v : {...v, name: e.target.value}))}/>
      </div>
      <div className="col-auto">
        <button type="button"
                className="btn btn-danger"
                onClick={() => { setModelAndNotify(model.filter(element => element !== item)) }}>
          <span className="material-icons align-middle">delete</span>
        </button>
      </div>
    </div>
  };

  const footer = <li className="list-group-item">
    <div className="row">
      <div className="col">
      </div>
      <div className="col-auto">
        <button type="button"
                className="btn btn-success"
                onClick={() => setModelAndNotify([...model, { hex: '' }])}>
          <span className="material-icons align-middle">add</span>
        </button>
      </div>
    </div>
  </li>;

  return <SubSection title="Colors" className="mb-3">
    <DraggableList value={model}
                   onChange={value => setModelAndNotify(value)}
                   itemRenderer={(item, i) => renderItem(item, i)}
                   header={header}
                   footer={footer}/>
  </SubSection>
};

export default Color;
